import { render, staticRenderFns } from "./PaymentCards.vue?vue&type=template&id=89961aa4&scoped=true&"
import script from "./PaymentCards.vue?vue&type=script&lang=js&"
export * from "./PaymentCards.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCards.vue?vue&type=style&index=0&id=89961aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89961aa4",
  null
  
)

export default component.exports